import { Controller } from "@hotwired/stimulus"

// Одностраничный визард web-генератора (web-06): показывает один шаг за раз,
// навигация next/prev, подсветка прогресса. Финальный submit — штатной формой.
export default class extends Controller {
  static targets = ["step", "dot"]
  static values = { start: Number }

  connect() {
    const last = this.stepTargets.length - 1
    this.index = Math.max(0, Math.min(this.startValue || 0, last))
    this.show()
  }

  next() {
    if (this.index < this.stepTargets.length - 1) {
      this.index++
      this.show()
    }
  }

  prev() {
    if (this.index > 0) {
      this.index--
      this.show()
    }
  }

  show() {
    this.stepTargets.forEach((step, i) => { step.hidden = i !== this.index })
    this.dotTargets.forEach((dot, i) => { dot.classList.toggle("is-active", i <= this.index) })
    this.element.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}
